// D-079 Editorial Imagery Alignment — premium hero photography references.
// All URLs are Unsplash CDN (royalty-free commercial use, no attribution required) selected
// to match the GIWAHS brand promise: modern clean manufacturing, craftsmanship, quality
// inspection, entrepreneurial collaboration, and global intelligence — never sweatshop or
// generic-stock aesthetics. Swap a URL at the constant below to refresh that page's hero
// without editing the page component itself.

const w = (id, width = 2400, quality = 80) =>
  `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${width}&q=${quality}`;

// Single source of truth for editorial hero imagery.
// D-084 VISUAL LOCK — the three home-band editorial images are now FROZEN to the
// Founder-approved compositions stored locally at /brand/heroes/*.jpg. Do NOT
// swap these to Unsplash / stock / alternate models. Replacement requires a new
// Founder directive (see directive 60).
export const EDITORIAL_HEROES = {
  // FGSD-001 · Home · Founder-directed replacement (supersedes D-087 lock).
  // Curated real photography — Unsplash photo-1534126511673-b6899657816a
  // (royalty-free commercial use). Garment craftsman at work in a dark,
  // warm-gold-lit atelier. Editorial · documentary · human · premium.
  // Represents: Craftsmanship · Manufacturing trust · Source with Confidence.
  home: {
    src: '/brand/heroes/home.jpg?v=95',
    alt: 'Garment craftsman at a sewing machine in a warm-lit atelier — manufacturing trust and craftsmanship',
    credit: 'Unsplash · FGSD-001 Founder-approved editorial replacement',
  },
  // D-087 · Factory Directory · FOUNDER-FINAL approved image — Vietnamese garment district
  // Source: Founder-supplied attachment (vgxbghs2 set · D-087 hero lock)
  // Represents: Execution · Authenticity · Real-world commerce · Supplier access ·
  //             Small/medium factory ecosystem. THÀNH CÔNG / PHƯỚC AN / VIỆT THANH / DŨNG PHÁT signage.
  factories: {
    src: '/brand/heroes/factories.jpg?v=94',
    alt: 'Vietnamese garment district — verified factory shopfronts, motorbikes, supplier commerce',
    credit: 'Founder-approved · D-087 final lock',
  },
  // D-087 · Product Directory · FOUNDER-FINAL approved image — sneaker wall on plinths
  // Source: Founder-supplied attachment (vgxbghs2 set · D-087 hero lock)
  // Represents: Desire · Commercial opportunity · Product discovery · Sneaker-head energy ·
  //             Catalogue depth.
  products: {
    src: '/brand/heroes/products.jpg?v=94',
    alt: 'Sneaker wall editorial — multi-brand catalogue depth on display plinths',
    credit: 'Founder-approved · D-087 final lock',
  },
  // Intelligence · global intelligence + connections (earth from space, warm gold city lights)
  intelligence: {
    src: w('photo-1451187580459-43490279c0fa'),
    alt: 'Earth from space at night — warm gold city lights tracing global connections',
    credit: 'Unsplash · global intelligence',
  },
  // Why GIWAHS Exists · entrepreneurs and buyers collaborating · trust and professionalism
  whyGiwahs: {
    src: w('photo-1521737604893-d14cc237f11d'),
    alt: 'Buyers and operators collaborating — laptops, documents, shared screens, trust',
    credit: 'Unsplash · entrepreneurial collaboration',
  },
};

export default EDITORIAL_HEROES;
